<template>
  <div id="wrapper" class="page" v-if="project_bonus_read">
    <!-- <contract-side-bar index="3" /> -->
    <div id="content-wrapper">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{ tieude }}
        </a>
        <b-card class="mt-3">
          <b-tabs content-class="mt-3" v-model="tabIndex">
            <b-tab title="Add personnel to the project">
              <b-row>
                <b-col cols="5">
                  <b-table
                    bordered
                    head-variant="dark"
                    hover
                    responsive
                    striped
                    small
                    table-variant="light"
                    :fields="employeeField"
                    :items="employees"
                  >
                    <template slot="top-row">
                      <td>
                        <b-form-input
                          v-model="employeeId_filter"
                          @keydown.enter.prevent="queryItem"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="name_filter"
                          @keydown.enter.prevent="queryItem"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-select
                          v-model="vitri_filter"
                          :options="Vitricongviecs"
                          value-field="id"
                          text-field="pickListValue"
                          @change="queryItem"
                        ></b-form-select>
                      </td>
                      <td>
                        <b-form-select
                          v-model="department_filter"
                          :options="Departments"
                          value-field="id"
                          text-field="madonvi"
                          @change="queryItem"
                        ></b-form-select>
                      </td>
                    </template>
                    <template v-slot:cell(tinhtranghoso)="data">{{
                      data.item.tinhtranghoso == null
                        ? ""
                        : findPickList(tinhtranghosos, data.item.tinhtranghoso)
                    }}</template>
                    <template v-slot:cell(vitricongviec)="data">{{
                      data.item.vitricongviec == null
                        ? ""
                        : findPickList(vitricongviecs, data.item.vitricongviec)
                    }}</template>
                    <template v-slot:cell(donvicongtac)="data">{{
                      data.item.donvicongtac == null
                        ? ""
                        : findDepartment(departments, data.item.donvicongtac)
                    }}</template>
                    <template v-slot:cell(action)="data">
                      <span v-show="!projectInfo.duan_lock">
                        <b-link
                          class="text-primary"
                          href="#"
                          @click.prevent="addEmployee(data)"
                        >
                          <i class="fas fa-user-plus"></i>
                          <!-- <button @click="addEmployee(data)"> -->
                          <!-- </button> -->
                        </b-link>
                      </span>
                    </template>
                    <!-- <template
                      v-slot:cell(action)="data"
                      v-show="data.item.tinhtranghoso == 0"
                    >
                      <span v-show="!projectInfo.duan_lock">
                        <b-link
                          class="text-primary"
                          href="#"
                          @click.prevent="addEmployee(data)"
                        >
                          <i class="fas fa-user-plus"></i>
                          <button @click="addEmployee(data)">
                          </button>
                        </b-link>
                      </span>
                    </template> -->
                  </b-table>
                </b-col>

                <b-col cols="7">
                  <b-row>
                    <b-card class="mb-3" no-body style="width: 100%">
                      <div
                        class="container-fluid"
                        style="width: 100%; padding: 20px"
                      >
                        <form
                          @submit.prevent="updateProject"
                          autocomplete="off"
                        >
                          <b-row class="mb-3">
                            <b-col cols="2">
                              <label class="mr-2">Profit rate</label>
                            </b-col>
                            <b-col cols="3">
                              <b-form-input
                                :value="projectInfo.duan_tylethuong + '%'"
                                readonly
                              ></b-form-input>
                            </b-col>
                            <b-col cols="2">
                              <label class="mr-2">Conversion rate</label>
                            </b-col>
                            <b-col cols="3">
                              <b-form-input
                                :readonly="projectInfo.duan_lock"
                                v-model.number="projectInfo.duan_quydoiusd"
                                type="number"
                                step="any"
                                required
                              ></b-form-input>
                            </b-col>
                            <b-col cols="2">
                              <button
                                :disabled="projectInfo.duan_lock"
                                class="btn btn-info"
                                type="submit"
                                style="float: right;"
                              >
                                <i class="fas fa-save"></i> Save
                                <!-- Lưu -->
                              </button>
                            </b-col>
                          </b-row>
                          <!-- <b-row class="mb-3">
                            <b-col cols="3">
                              <label class="mr-2">Conversion rate</label>
                            </b-col>
                            <b-col cols="9">
                              <b-form-input
                                :readonly="projectInfo.duan_lock"
                                v-model.number="projectInfo.duan_quydoiusd"
                                type="number"
                                step="any"
                                required
                              ></b-form-input>
                            </b-col>
                          </b-row> -->
                          <b-row>
                            <b-col cols="2">
                              <label class="mr-2">Closing date</label>
                            </b-col>
                            <b-col cols="3">
                              <my-date-picker
                                :disabled="projectInfo.duan_lock"
                                v-model="ngaydukienthanhtoan_selected"
                              ></my-date-picker>
                            </b-col>
                            <b-col cols="2">
                              <label class="mr-2">Payment date</label>
                            </b-col>
                            <b-col cols="3">
                              <my-date-picker
                                v-model="ngaythanhtoan_selected"
                                disabled
                              ></my-date-picker>
                            </b-col>
                            <b-col cols="2">
                              <span v-if="!projectInfo.duan_lock">
                                <button
                                  class="btn btn-outline-success"
                                  type="button"
                                  style="float: right;"
                                  @click.prevent="changeLock"
                                >
                                  <i
                                    class="fas fa-lock"
                                    style="color:green"
                                  ></i>
                                  Lock
                                </button>
                              </span>
                              <span v-else>
                                <button
                                  class="btn btn-outline-dark"
                                  type="button"
                                  style="float: right;"
                                  @click.prevent="changeLock"
                                >
                                  <i class="fas fa-unlock-alt"></i> Unlock
                                </button>
                              </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="2">
                              <label class="mr-2">Note</label>
                            </b-col>
                            <b-col cols="8">
                              <b-form-textarea
                                v-model="projectInfo.duan_note"
                                rows="2"
                              ></b-form-textarea>
                            </b-col>
                            <b-col cols="2"> </b-col>
                          </b-row>
                        </form>
                      </div>
                    </b-card>
                  </b-row>

                  <b-row>
                    <b-table
                      bordered
                      head-variant="dark"
                      hover
                      responsive
                      striped
                      small
                      table-variant="light"
                      :fields="projectField"
                      :items="projects"
                    >
                      <template v-slot:cell(donvicongtac)="data">{{
                        data.item.donvicongtac == null
                          ? ""
                          : findDepartment(departments, data.item.donvicongtac)
                      }}</template>
                      <template v-slot:cell(vitri)="data">
                        <b-link
                          :disabled="projectInfo.duan_lock"
                          href="#"
                          @click.prevent="openEmployeeModal(data)"
                        >
                          {{
                            data.item.employeecontractbonusid == null
                              ? ""
                              : findBonusPosition(
                                  employeecontractbonuses,
                                  data.item.employeecontractbonusid
                                )
                          }}
                        </b-link>
                      </template>
                      <template v-slot:cell(sotienthanhtoan)="data">{{
                        data.item.sotienthanhtoan | numeral("0,0")
                      }}</template>
                      <template v-slot:cell(sotien)="data">{{
                        (data.item.employeecontractbonusid == null
                          ? ""
                          : findBonusMoney(
                              employeecontractbonuses,
                              data.item.employeecontractbonusid
                            )) | numeral("0,0")
                      }}</template>
                      <template v-slot:cell(currency)="data">{{
                        data.item.employeecontractbonusid == null
                          ? ""
                          : findCurrency(
                              employeecontractbonuses,
                              data.item.employeecontractbonusid
                            )
                      }}</template>
                      <template v-slot:cell(sendmail)="data">
                        <span
                          class="text-success"
                          v-if="data.item.sendmail != null"
                        >
                          <i class="fas fa-check"></i>
                        </span>
                      </template>
                      <template v-slot:cell(action2)="data">
                        <span v-show="!projectInfo.duan_lock">
                          <b-link
                            class="text-primary mr-2"
                            href="#"
                            @click="openEmployeeModal(data)"
                          >
                            <i class="fas fa-pencil-alt"></i>
                          </b-link>
                          <b-link
                            class="text-danger"
                            href="#"
                            @click.prevent="removeEmployee(data)"
                          >
                            <i class="fas fa-trash"></i>
                          </b-link>
                        </span>
                      </template>
                      <template slot="bottom-row">
                        <td style="text-align:center" colspan="4">
                          <b>TOTAL</b>
                        </td>
                        <td style="text-align:right">
                          <b>{{ sum_point }}</b>
                        </td>
                        <td style="text-align:right" colspan="3">
                          <b>{{ sum_total | numeral("0,0") }}</b>
                        </td>
                        <!-- <td style="text-align:right"></td> -->

                        <td style="text-align:center" colspan="3"></td>
                      </template>
                    </b-table>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>

            <!-- Bỏ quyền con xem chi phí -->
            <b-tab title="Cost">
              <!-- <b-tab title="Cost" v-if="profit_and_loss"> -->
              <container>
                <b-row class="mb-4">
                  <b-col cols="3">
                    <label class="mr-2">Cost</label>
                    <form
                      @submit.prevent="calculateProfit"
                      class="form-inline mb-4"
                    >
                      <div class="form-group mr-3">
                        <my-currency-input v-model="item.chiphi" />
                      </div>
                      <button
                        class="btn btn-info"
                        type="submit"
                        :disabled="projectInfo.duan_lock"
                      >
                        <i class="fas fa-plus"></i> Cost calculation
                      </button>
                    </form>
                  </b-col>
                  <b-col cols="3">
                    <b-row>
                      <b-col cols="3">
                        <label class="mr-2">Revenue</label>
                      </b-col>
                      <b-col cols="2">
                        <b-form-checkbox v-model="projectInfo.vat"
                          >VAT</b-form-checkbox
                        >
                      </b-col>
                    </b-row>
                    <form
                      @submit.prevent="updateProject"
                      class="form-inline mb-4"
                    >
                      <div class="form-group mr-3">
                        <my-currency-input v-model="projectInfo.duan_revenue" />
                      </div>
                      <button
                        class="btn btn-info"
                        type="submit"
                        :disabled="projectInfo.duan_lock"
                      >
                        <i class="fas fa-plus"></i> Update
                      </button>
                    </form>
                  </b-col>
                </b-row>
                <b-row class="mb-4">
                  <!-- <b-col cols="3">
                    <label class="mr-2">Doanh thu</label>
                    <b-form-input
                      :value="item.giatriduocnghiemthu | numeral('0,0')"
                      readonly
                    ></b-form-input>
                  </b-col> -->
                  <b-col cols="3">
                    <label class="mr-2">Profit</label>
                    <b-form-input
                      :value="profit | numeral('0,0')"
                      readonly
                    ></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <label class="mr-2">Return on sales</label>
                    <b-form-input
                      v-model="profit_percentage"
                      readonly
                    ></b-form-input>
                  </b-col>
                </b-row>
              </container>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

      <b-modal
        v-model="employeeModalShow"
        header-bg-variant="info"
        header-text-variant="light"
        @hidden="closeEmployeeModal"
        @cancel="closeEmployeeModal"
        @ok="storeProjectEmployee"
        style="white-space: pre-wrap;"
      >
        <template v-slot:modal-title>
          <div>Detail</div>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
          <!-- <b-button v-if="!updating" variant="success" @click="ok()">Save</b-button>
                <b-button v-else variant="success" @click="updateHistory">Update</b-button> -->
          <b-button variant="info" @click="ok()">Save</b-button>
          <!-- Lưu -->
          <b-button variant="dark" @click="cancel()">Close</b-button>
        </template>
        <b-form autocomplete="off">
          <b-container>
            <b-row class="mb-4">
              <b-col cols="3">
                <label class="mr-2">Point</label>
                <code>*</code>
              </b-col>
              <b-col cols="9">
                <b-form-input
                  v-model.number="diem"
                  type="number"
                  step="0.5"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="3">
                <label class="mr-2">Position</label>
              </b-col>
              <b-col cols="9">
                <!-- <b-form-select v-model="vaitro" :options="vaitros" value-field="id" text-field="pickListValue" @change="changeVitri"></b-form-select> -->
                <b-form-select
                  v-model="vaitro"
                  :options="vaitros"
                  value-field="id"
                  text-field="pickListValue"
                ></b-form-select>
              </b-col>
              <!-- <div>
                        {{this.vaitro}}
                      </div> -->
            </b-row>
            <b-row class="mb-4">
              <b-col cols="3">
                <label class="mr-2">Note</label>
              </b-col>
              <b-col cols="9">
                <b-form-textarea
                  v-model="note_employee"
                  rows="4"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="3">
                <label class="mr-2">Sent Email</label>
              </b-col>
              <b-col cols="9">
                <!-- Trang thai la null: khong cho check da gui mail -->
                <b-form-checkbox v-model="issendmail">
                  <!-- value="true" 
                  unchecked-value="null"
                  :disabled="!this.sendemail" -->
                </b-form-checkbox>
                <!-- <b-form-input v-model="text" :placeholder="new Date()"></b-form-input> -->
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import ContractSideBar from "../components/Contract/ContractSideBar";
import MyCurrencyInput from "../components/App/MyCurrencyInput";
import MyDatePicker from "../components/App/MyDatePicker.vue";

export default {
  name: "ProjectUpdate",
  components: {
    //ContractSideBar,
    MyCurrencyInput,
    MyDatePicker,
  },
  data() {
    return {
      tabIndex: 0, //Chọn tab
      employeeField: [
        {
          key: "manhanvien",
          label: "Code",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "60px", textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "donvicongtac",
          label: "Company",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
      ],

      projectField: [
        //  {
        //       key: "action",
        //       label: "",
        //       tdClass: "text-center",
        //       thClass: "align-middle",
        //       thStyle: { width: "25px !important" },
        //   },
        {
          key: "manhanvien",
          label: "Code",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "60px", textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "donvicongtac",
          label: "Com",
          thClass: "align-middle",
          thStyle: { width: "50px", textAlign: "center" },
        },
        {
          key: "vitri",
          label: "Position",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "diem",
          label: "Point",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "60px", textAlign: "center" },
        },
        {
          key: "sotien",
          label: "Bonus Rate",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "60px", textAlign: "center" },
        },
        {
          key: "currency",
          label: "Currency",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "sotienthanhtoan",
          label: "Total",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
        },
        {
          key: "note",
          label: "Note",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "sendmail",
          label: "Email",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "50px", textAlign: "center" },
        },
        {
          key: "action2",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "65px !important" },
        },
      ],

      projectInfo: {
        customercontractid: 0,
        duan_tylethuong: null,
        duan_quydoiusd: null,
        duan_ngaythanhtoan: null,
        duan_ngaydukienthanhtoan: null,
        duan_note: null,
        duan_lock: 0,
        duan_revenue: 0,
        vat: false,
      },

      ngaythanhtoan_selected: null,
      ngaydukienthanhtoan_selected: null,

      customercontractid: 0,
      employees: [],
      projects: [],
      departments: [],
      vitricongviecs: [],
      tinhtranghosos: [],
      vaitros: [],
      employeecontractbonuses: [],

      //Modal Detail
      vaitro: null,
      diem: 1,
      // sendemail: null,
      issendmail: null,
      note_employee: null,
      employee_index: -1,

      employeeModalShow: false,
      projectItem: {
        id: 0,
        customercontractid: 0,
        employeeid: 0,
        employeecontractbonusid: 0,
        vaitrotrongduan: null,
        diem: 1,
        sotienthanhtoan: 0,
        note: null,
        sendmail: null,
      },

      employeeId_filter: "",
      name_filter: "",
      vitri_filter: "",
      department_filter: "",
      status_filter: "",

      tieude: "",

      //TAB Profit
      item: {
        id: 0,
        tieude: null,
        sohopdong: null,
        loaihinhhopdong: 0,
        giatrihopdong: 0,
        giatriduocnghiemthu: 0,
        phamvicongviec: "",
        thoigiansudung: null,
        ngayky: "",
        ngaybatdau: "",
        ngayketthuc: "",
        ngaybangiao: "",
        ngaybangiaothucte: "",
        ngayphatsong: "",
        ngayxacnhannghiemthu: "",
        ngaynghiemthu: "",
        dacdiem: 0,
        kenhduocsudung: "",
        departmentid: null,
        chiphi: 0,
        dathu: 0,

        ngayhieuluc: "",
        ngayhethan: "",
        tinhtrang: null,

        customer: null,
        customerId: null,
        diachi: null,
        dienthoai: null,
        email: null,
        masothue: null,
        taikhoannganhang: null,
        customercontactid: null,

        duan_tylethuong: null,
      },
      profit: 0,
      profit_percentage: "",
      url: "/api/customercontract/",
    };
  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/customercontract/${to.params.id}`), //TAB CHI PHI
        axios.get(`/api/employee/project/${to.params.id}`),
        axios.get("/api/department"),
        axios.get("/api/picklist?q=vitricongviec"),
        axios.get("/api/picklist?q=tinhtranghoso"),
        axios.get(`/api/customercontract/project/${to.params.id}`),
        axios.get(`/api/customercontract/projectinfo/${to.params.id}`),
        axios.get("/api/employeecontractbonus"),
      ])
      .then(
        axios.spread(
          (
            customercontract,
            employee,
            department,
            vitricongviec,
            tinhtranghoso,
            project,
            projectinfo,
            employeecontractbonus
          ) => {
            next((vm) =>
              vm.initData(
                customercontract.data,
                employee.data,
                department.data,
                vitricongviec.data,
                tinhtranghoso.data,
                project.data,
                projectinfo.data,
                employeecontractbonus.data
              )
            );
          }
        )
      );
  },

  beforeRouteUpdate(to, from, next) {
    axios
      .get(`/api/employee/project/${to.params.id}`, { params: to.query })
      .then((response) => {
        this.employees = response.data;
        // next();
      })
      .catch((err) => {
        next();
      });
  },

  watch: {
    // ngaythanhtoan_selected: function (newValue, oldValue) {
    //   this.projectInfo.duan_ngaythanhtoan = this.$convert_string_date(newValue);
    // },
    // ngaydukienthanhtoan_selected: function (newValue, oldValue) {
    //   this.projectInfo.duan_ngaydukienthanhtoan = this.l$convert_string_date(newValue);
    // }
  },

  computed: {
    project_bonus_read() {
      return this.$store.getters.hasPermission("project_bonus_read");
    },
    sum_total() {
      var sum = 0;
      for (var item of this.projects) {
        sum += item.sotienthanhtoan;
      }
      return sum;
    },
    sum_point() {
      let sum = 0;
      for (let item of this.projects) {
        sum += item.diem;
      }
      return sum;
    },
    profit_and_loss() {
      return this.$store.getters.hasPermission("profit_and_loss");
    },
    Vitricongviecs() {
      const null_value = { id: "", pickListValue: "" };
      var result = this.vitricongviecs.slice();
      result.unshift(null_value);

      return result;
    },
    Trangthaihosos() {
      const null_value = { id: "", pickListValue: "" };
      var result = this.tinhtranghosos.slice();
      result.unshift(null_value);

      return result;
    },
    Departments() {
      const null_value = { id: "", madonvi: "" };
      var result = this.departments.slice();
      result.unshift(null_value);

      return result;
    },
  },

  methods: {
    initData(
      customercontracts,
      employees,
      departments,
      vitricongviecs,
      tinhtranghosos,
      projects,
      projectinfo,
      employeecontractbonuses
    ) {
      this.item = customercontracts;
      this.customercontractid = projectinfo.customercontractid;
      this.employees = employees;
      this.departments = departments;
      this.vitricongviecs = vitricongviecs;
      this.tinhtranghosos = tinhtranghosos;
      this.projects = projects;
      this.employeecontractbonuses = employeecontractbonuses;

      this.projectInfo.customercontractid = projectinfo.customercontractid;
      this.projectInfo.duan_tylethuong = projectinfo.duan_tylethuong;
      this.projectInfo.duan_quydoiusd = projectinfo.duan_quydoiusd;
      this.projectInfo.vat = this.item.vat;
      this.ngaythanhtoan_selected = this.$convert_date_string(
        projectinfo.duan_ngaythanhtoan
      );
      this.ngaydukienthanhtoan_selected = this.$convert_date_string(
        projectinfo.duan_ngaydukienthanhtoan
      );
      //this.projectInfo.duan_ngaythanhtoan = this.ngaythanhtoan_selected;
      this.projectInfo.duan_ngaydukienthanhtoan = this.ngaydukienthanhtoan_selected;

      this.tieude = projectinfo.tieude;
      this.projectInfo.duan_lock = projectinfo.duan_lock;
      this.projectInfo.duan_note = projectinfo.duan_note;
      this.projectInfo.duan_revenue = projectinfo.duan_revenue;

      //TAB CHI PHI
      this.calculateChiPhi();
    },
    changeLock() {
      var lock = 1;
      if (this.projectInfo.duan_lock) lock = 0;
      if (
        lock == 1 &&
        (this.projectInfo.duan_ngaydukienthanhtoan == null ||
          this.projectInfo.duan_ngaydukienthanhtoan == "")
      ) {
        this.$toast.error("There is no closing date. Can't lock!", "Error", {
          timeout: 3000,
        });
        return;
      }

      if (
        lock == 1 &&
        this.projectInfo.duan_ngaydukienthanhtoan !=
          this.ngaydukienthanhtoan_selected
      ) {
        this.$toast.error("Can't save closing date. Can't lock!", "Error", {
          timeout: 3000,
        });
        return;
      }

      axios
        .put(
          `/api/customercontract/lockproject/${this.projectInfo.customercontractid}/${lock}`
        )
        .then((res) => {
          if (lock == 1) {
            this.$toast.success("Successful lock !", "Success", {
              timeout: 2000,
            });
            this.$router.go(-1);
          } else {
            this.$toast.info("Please wait!", "LOADING", { timeout: 3000 });
            this.$router.go(0);
          }
        });
    },
    addEmployee(data) {
      axios
        .post(
          `/api/customercontract/project/${data.item.id}/${this.customercontractid}`
        )
        .then((res) => {
          this.projects.push({
            id: res.data.id,
            manhanvien: data.item.manhanvien,
            hovaten: data.item.hovaten,
            donvicongtac: data.item.donvicongtac,
            employeecontractbonusid: res.data.employeecontractbonusid,
            customercontractid: res.data.customercontractid,
            employeeid: res.data.employeeid,
            sotienthanhtoan: res.data.sotienthanhtoan,
            diem: 1,
          });
          this.$toast.success("Add personnel Successful!", "Success", {
            timeout: 2000,
          });
          //this.projects.push({id: data.item.id, manhanvien:  data.item.manhanvien, hovaten: data.item.hovaten, vitricongviec: data.item.vitricongviec, donvicongtac: data.item.donvicongtac, tinhtranghoso: data.item.tinhtranghoso});
          //this.employees.splice(data.index, 1);
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    removeEmployee(data) {
      axios
        .delete(`/api/customercontract/project/${data.item.id}`)
        .then((res) => {
          //this.employees.unshift({id: data.item.id, manhanvien:  data.item.manhanvien, hovaten: data.item.hovaten, vitricongviec: data.item.vitricongviec, donvicongtac: data.item.donvicongtac, tinhtranghoso: data.item.tinhtranghoso});
          this.projects.splice(data.index, 1);
        });
    },
    findBonusPosition(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return this.findPickList(this.vitricongviecs, temp.vitricongviec);
    },
    findBonusMoney(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp.vnd == 0 ? temp.tien : temp.vnd;
    },
    findCurrency(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp.vnd == 0 ? "USD" : "VND";
    },
    findPickList(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },
    openEmployeeModal(data) {
      this.employeeModalShow = true;
      this.vaitro = this.employeecontractbonuses.find(function(el) {
        if (el.id == data.item.employeecontractbonusid) return el;
      }).vitricongviec;
      this.diem = data.item.diem;
      this.note_employee = data.item.note;
      this.issendmail = data.item.sendmail == null ? false : true; // Chuyen gia tri ngay thang thanh TRUE

      this.projectItem.id = data.item.id;
      this.projectItem.customercontractid = data.item.customercontractid;
      this.projectItem.employeeid = data.item.employeeid;
      this.projectItem.employeecontractbonusid =
        data.item.employeecontractbonusid;
      this.employee_index = data.index;

      axios
        .get(`/api/picklist/employeebonus/${data.item.employeecontractbonusid}`)
        .then((res) => {
          this.vaitros = res.data;
        });
    },
    closeEmployeeModal() {
      this.employeeModalShow = false;
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q =
        this.employeeId_filter +
        "|" +
        this.name_filter +
        "|" +
        this.vitri_filter +
        "|" +
        this.department_filter +
        "|" +
        this.status_filter;
      this.$router.push({ query: query });
    },

    goBack() {
      //this.$router.go(-1);
      this.$router.push("/project");
    },
    updateProject() {
      this.projectInfo.duan_ngaydukienthanhtoan = this.$convert_string_date(
        this.ngaydukienthanhtoan_selected
      );
      this.projectInfo.duan_ngaythanhtoan = this.$convert_string_date(
        this.ngaythanhtoan_selected
      );
      this.projectInfo.duan_quydoiusd = parseFloat(
        this.projectInfo.duan_quydoiusd
      );

      axios
        .put("/api/customercontract/projectinfo", this.projectInfo)
        .then((res) => {
          this.projectInfo.duan_ngaydukienthanhtoan = this.ngaydukienthanhtoan_selected;
          this.projectInfo.duan_revenue = res.data.revenue;
          this.calculateChiPhi();
          if (res.data.change) {
            this.$toast.info("Please wait!", "LOADING", { timeout: 3000 });
            this.$router.go(0);
          } else
            this.$toast.success("Update information successful!", "Success", {
              timeout: 2000,
            });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    // changeVitri() {
    //     this.projectItem.vaitrotrongduan = this.vaitro;
    //     axios.put("/api/customercontract/project", this.projectItem)
    //     .then((res) => {
    //         this.projects[this.employee_index].employeecontractbonusid = res.data.employeecontractbonusid;
    //         this.closeEmployeeModal();
    //     })
    //     .catch((err) => {this.$toast.error(err.response.data, "Error", { timeout: 3000 });});
    // },
    storeProjectEmployee() {
      this.projectItem.vaitrotrongduan = this.vaitro;
      this.projectItem.diem = this.diem;
      this.projectItem.note = this.note_employee;
      if (this.issendmail == false) this.projectItem.sendmail = null;
      else this.projectItem.sendmail = new Date();
      axios
        .put("/api/customercontract/project", this.projectItem)
        .then((res) => {
          this.$toast.success("Update successful!", "Success", {
            timeout: 3000,
          });

          this.projects[this.employee_index].employeecontractbonusid =
            res.data.employeecontractbonusid;
          this.projects[this.employee_index].sotienthanhtoan =
            res.data.sotienthanhtoan;
          this.projects[this.employee_index].diem = res.data.diem;
          this.projects[this.employee_index].note = res.data.note;
          this.projects[this.employee_index].sendmail = res.data.sendmail; //chu y sendemail , db la sendmail
          //Khong refresh
          this.closeEmployeeModal();
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    //TAB CHI PHI
    calculateProfit() {
      this.profit = this.projectInfo.duan_revenue - this.item.chiphi;
      this.profit_percentage =
        (
          ((this.projectInfo.duan_revenue - this.item.chiphi) /
            this.projectInfo.duan_revenue) *
          100
        ).toFixed(2) + "%";

      this.item.duan_tylethuong = parseFloat(this.profit_percentage);
      //Them ben tab Them nhan su
      this.projectInfo.duan_tylethuong = parseFloat(this.profit_percentage);

      axios
        //Chi update truong chi phi
        //.put("/api/customercontract", this.item)
        .patch(this.url, this.item)
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    calculateChiPhi() {
      this.profit = this.projectInfo.duan_revenue - this.item.chiphi;
      if (
        this.projectInfo.duan_revenue == 0 ||
        this.projectInfo.duan_revenue == null
      ) {
        this.profit_percentage = 0;
        return;
      }
      this.profit_percentage =
        (
          ((this.projectInfo.duan_revenue - this.item.chiphi) /
            this.projectInfo.duan_revenue) *
          100
        ).toFixed(2) + "%";
    },
  },
};
</script>
